import initialState from './initialState';
import {
  FETCH_DYNAMIC_LIST_INIT,
  FETCH_DYNAMIC_LIST_INIT_ITEM,
  FETCH_DYNAMIC_LIST_SUCCESS,
  FETCH_DYNAMIC_LIST_SUCCESS_ITEM,
  FETCH_DYNAMIC_LIST_FAILURE,
  FETCH_DYNAMIC_LIST_FAILURE_ITEM,
  RESET_DYNAMIC_LIST,
  RESET_DYNAMIC_LIST_ITEM,
  SET_DYNAMIC_LIST,
  SET_DYNAMIC_LIST_ITEM,
  FETCH_DYNAMIC_LIST_DELETE_FAILURE,
  FETCH_DYNAMIC_LIST_DELETE_SUCCESS,
  FETCH_DYNAMIC_LIST_DELETE_INIT,
  FETCH_DYNAMIC_LIST_ALL_INIT,
  FETCH_DYNAMIC_LIST_ALL_SUCCESS,
  FETCH_DYNAMIC_LIST_ALL_FAILURE,
  FETCH_LIST_CONCAT,
  DELETE_LIST_FROM_STORE,
  FETCH_DYNAMIC_ITEM_ALL_INIT,
  FETCH_DYNAMIC_ITEM_ALL_SUCCESS,
  FETCH_DYNAMIC_ITEM_ALL_FAILURE,
  RESET_ITEMS,
  CONCAT_ITEMS,
  EDIT_ITEM_INIT,
  EDIT_ITEM_FAILURE,
  EDIT_ITEM_SUCCESS,
  EDIT_ITEMS_INIT,
  EDIT_ITEMS_FAILURE,
  EDIT_ITEMS_SUCCES,
  DELETE_ITEM_INIT,
  DELETE_ITEM_FAILURE,
  DELETE_ITEM_SUCCES,
  DELETE_ITEM,
  DELETE_ITEM_ONCE
} from '../../actions/dynamic_list/types';

export default function dynamicList(state = initialState, action) {
  switch (action.type) {
    case FETCH_DYNAMIC_LIST_INIT:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_DYNAMIC_LIST_SUCCESS:
      if (action.payload.status != 500) {
        return {
          ...state,
          datos: action.payload.data,
          error: null,
          loading: false,
          status: action.payload.status,
          statusFail: null
        };
      } else {
        return {
          ...state,
          loading: false,
          status: 200,
          statusFail: action.payload.status
        };
      }

    case FETCH_DYNAMIC_LIST_FAILURE:
      return {
        ...state,
        datos: {},
        error: action.payload,
        loading: false
      };
    case RESET_DYNAMIC_LIST:
      return {
        ...state,
        datos: {},
        loading: true,
        error: null,
        status: null
      };
    case SET_DYNAMIC_LIST:
      return {
        ...state,
        datos: {},
        loading: true,
        error: null,
        status: null
      };
    /* DELETE LIST */
    case FETCH_DYNAMIC_LIST_DELETE_INIT:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: true
        }
      };
    case FETCH_DYNAMIC_LIST_DELETE_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: false,
          datos: action.payload
        }
      };
    case FETCH_DYNAMIC_LIST_DELETE_FAILURE:
      return {
        ...state,
        delete: {
          ...state.delete,
          loading: false,
          datos: {},
          error: action.payload
        }
      };
    /* ITEM */
    case FETCH_DYNAMIC_LIST_INIT_ITEM:
      return {
        ...state,
        item: {
          ...state.item,
          loading: true,
          error: null
        }
      };
    case FETCH_DYNAMIC_LIST_SUCCESS_ITEM:
      return {
        ...state,
        item: {
          ...state.item,
          loading: false,
          datos: action.payload,
          error: null
        }
      };
    case FETCH_DYNAMIC_LIST_FAILURE_ITEM:
      return {
        ...state,
        item: {
          ...state.item,
          loading: false,
          datos: {},
          error: action.payload
        }
      };

    // Get all list
    case FETCH_DYNAMIC_LIST_ALL_INIT:
      return {
        ...state,
        lists: {
          ...state.lists,
          loading: true,
          datos: [],
          error: null
        }
      };
    case FETCH_DYNAMIC_LIST_ALL_FAILURE:
      return {
        ...state,
        lists: {
          ...state.lists,
          loading: false,
          datos: [],
          error: action.payload,
          status: action.payload.status
        }
      };
    case FETCH_DYNAMIC_LIST_ALL_SUCCESS:
      return {
        ...state,
        lists: {
          ...state.lists,
          loading: false,
          datos: [...state.lists.datos, ...action.payload.data.response],
          error: null,
          status: action.payload.status
        }
      };
    case FETCH_LIST_CONCAT:
      return {
        ...state,
        lists: {
          ...state.lists,
          datos: [...state.lists.datos, ...[state.datos]]
        }
      };
    case DELETE_LIST_FROM_STORE:
      let newDatos = [...state.lists.datos].filter(item => {
        return item.id != parseInt(action.payload);
      });

      return {
        ...state,
        lists: {
          ...state.lists,
          datos: [...newDatos]
        }
      };

    case FETCH_DYNAMIC_ITEM_ALL_INIT:
      if (action.list) {
        return {
          ...state,
          items: {
            ...state.items,
            loading: false
          }
        };
      } else {
        return {
          ...state,
          items: {
            ...state.items,
            loading: true
          }
        };
      }

    case FETCH_DYNAMIC_ITEM_ALL_FAILURE:
      return {
        ...state,
        items: {
          ...state.items,
          loading: false,
          error: action.payload
        }
      };
    case FETCH_DYNAMIC_ITEM_ALL_SUCCESS:
      if (action.list) {
        return {
          ...state,
          items: {
            ...state.items,
            loading: false,
            status: action.payload.status,
            hasitem: [/*...state.items.datos,*/ ...action.payload.data.response]
          }
        };
      } else {
        return {
          ...state,
          items: {
            ...state.items,
            loading: false,
            status: action.payload.status,
            datos: [/*...state.items.datos,*/ ...action.payload.data.response]
          }
        };
      }

    case RESET_ITEMS:
      return {
        ...state,
        items: {
          ...state.items,
          loading: false,
          status: null,
          datos: [],
          error: null
        }
      };

    case CONCAT_ITEMS:
      return {
        ...state,
        items: {
          ...state.items,
          datos: [...state.items.datos, ...[action.payload]]
        }
      };

    case EDIT_ITEM_INIT:
      return {
        ...state
        // editedItem: {
        //   ...state.editedItem,
        //   loading: true
        // }
      };
    case EDIT_ITEM_FAILURE:
      return {
        ...state
        // editedItem: {
        //   ...state.editedItem,
        //   loading: false,
        //   error: action.payload
        // }
      };

    case EDIT_ITEM_SUCCESS:
      const updatedObject = {
        //id: parseInt(action.payload.obj.itemId),
        id: action.payload.obj.itemId,
        name: action.payload.obj.itemName
      };
      //--------------------------------------------------------

      const newDataItem = [
        ...state.items.datos.slice(0, parseInt(action.payload.index)),
        updatedObject,
        ...state.items.datos.slice(parseInt(action.payload.index) + 1)
      ];
      return {
        ...state,
        items: {
          ...state.items,
          datos: [...newDataItem]
        }
      };

    case EDIT_ITEMS_INIT:
      return {
        ...state,
        editedItem: {
          ...state.editedItem,
          loading: true
        }
      };
    case EDIT_ITEMS_FAILURE:
      return {
        ...state,
        editedItem: {
          ...state.editedItem,
          loading: false,
          error: action.payload
        }
      };

    case EDIT_ITEMS_SUCCES:
      return {
        ...state,
        editedItem: {
          ...state.editedItem,
          loading: false,
          error: null,
          result: action.payload.data.data.response,
          status: action.payload.data.status
        }
        //datos: [...state.items.datos]
      };

    case DELETE_ITEM_ONCE:
      const newItemArr = [
        ...state.items.datos.slice(0, parseInt(action.payload.index)),
        ...state.items.datos.slice(parseInt(action.payload.index) + 1)
      ];

      return {
        ...state,
        items: {
          ...state.items,
          datos: [...newItemArr]
        }
      };

    case DELETE_ITEM_INIT:
      return {
        ...state,
        deletedItem: {
          ...state.deletedItem,
          loading: true
        }
      };
    case DELETE_ITEM_FAILURE:
      return {
        ...state,
        deletedItem: {
          ...state.deletedItem,
          loading: false,
          error: action.payload,
          status: action.payload.status
        }
      };

    case DELETE_ITEM_SUCCES:
      return {
        ...state,
        deletedItem: {
          ...state.deletedItem,
          loading: false,
          result: action.payload.data.data.response,
          status: action.payload.data.data.status
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./source/client/reducers/dynamic_list/index.js